const currencyPaths = {
	GET_CURRENCY: (venueId) => venueId,
};

export default currencyPaths;
